import React, { Component } from 'react';

class WhatCities extends Component {
  render() {
    return (
      <div className="fm-container">
        <p className="fm-webview-text">Flamingo currently operates in Wellington and Christchurch.</p>
      </div>
    );
  }
}

export default WhatCities;
